import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { changeBoxInfoStepCompleted, onCloseBoxBuilderPopup } from '../../../../../redux/box-builder/box-builder.actions';
import { hasUnsavedChangesSelector } from '../../../../../redux/box-builder/box-builder.selectors';
import BoxIntroductionInfo from './box-introduction-info';
const mapStateToProps = createStructuredSelector({
  hasUnsavedChanges: hasUnsavedChangesSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: onCloseBoxBuilderPopup(dispatch),
  onNext: () => {
    dispatch(changeBoxInfoStepCompleted(true));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(BoxIntroductionInfo);